import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class CoreDataShareService {
  private reviewDataObserable = new BehaviorSubject<any>([]);
  reviewData = this.reviewDataObserable.asObservable();
  translations$ = new BehaviorSubject<ITranslation>(null);
  private appliedServiceList = new BehaviorSubject<any>([]);
  appliedServiceList$ = this.appliedServiceList.asObservable();
  private formData: {};
  private temporaryRouteId: number;
  private currFormGroup: FormGroup;

  /**
   * This method will set translations
   * @param data - data
   */
  setTranslations(data: ITranslation) {
    this.translations$.next(data);
  }

  set currentFormGroup(formGroup: FormGroup) { this.currFormGroup = formGroup; }
  get currentFormGroup() { return this.currFormGroup; }

  /**
   * observable to update review data
   * @param data - data
   */
  updateReviewData(data: object) { this.reviewDataObserable.next(data); }

  /**
   * observable to set applied services
   * @param values - values
   */
  setAppliedServices(values: Array<any>) { this.appliedServiceList.next(values); }

  /**
   * observable to get applied services
   */
  getAppliedServices() { return this.appliedServiceList.value; }


  public get formDataWithModuleName() {
    return this.formData;
  }


  public set formDataWithModuleName(formData) {
    this.formData = formData;
  }

  get tempRouteId(): number { return this.temporaryRouteId; }

  set tempRouteId(routeId: number) { this.temporaryRouteId = routeId; }


}

export interface ITranslation {
  lang: string;
  data: object;
}
